(function () {
  'use strict';

  var theme = window.theme || { strings: {}, routes: {} };

  /* Money formatting using the shop's money format */
  function formatMoney(cents) {
    var format = theme.moneyFormat || '{{amount}}';
    var value = (cents / 100);
    function withDelimiters(num, precision, thousands, decimal) {
      var parts = num.toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(value, 2, "'", '.');
        default: return withDelimiters(value, 2, ',', '.');
      }
    });
  }

  /* Menu drawer */
  var drawer = document.getElementById('MenuDrawer');
  var openBtn = document.querySelector('[data-menu-open]');
  function openMenu() {
    if (!drawer) return;
    drawer.hidden = false;
    document.documentElement.classList.add('menu-open');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    var close = drawer.querySelector('[data-menu-close]');
    if (close) close.focus();
  }
  function closeMenu() {
    if (!drawer) return;
    drawer.hidden = true;
    document.documentElement.classList.remove('menu-open');
    if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); }
  }
  if (openBtn) openBtn.addEventListener('click', openMenu);
  if (drawer) {
    drawer.querySelectorAll('[data-menu-close]').forEach(function (b) { b.addEventListener('click', closeMenu); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) closeMenu(); });
  }

  /* Back arrow: go back within the site when possible */
  document.querySelectorAll('[data-back-link]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      try {
        if (document.referrer && new URL(document.referrer).origin === location.origin && history.length > 1) {
          e.preventDefault();
          history.back();
        }
      } catch (err) { /* fall through to href */ }
    });
  });

  /* Footer accordions open on desktop */
  var desktop = window.matchMedia('(min-width: 990px)');
  function syncFooter() {
    document.querySelectorAll('[data-footer-accordion]').forEach(function (d) {
      if (desktop.matches) d.setAttribute('open', '');
      else d.removeAttribute('open');
    });
  }
  syncFooter();
  if (desktop.addEventListener) desktop.addEventListener('change', syncFooter);

  /* Quantity steppers */
  var cartForm = document.querySelector('[data-cart-form]');
  var cartTimer;
  function submitCart() {
    if (!cartForm) return;
    clearTimeout(cartTimer);
    cartTimer = setTimeout(function () {
      var flag = document.createElement('input');
      flag.type = 'hidden'; flag.name = 'update'; flag.value = '1';
      cartForm.appendChild(flag);
      cartForm.submit();
    }, 500);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var input = btn.closest('[data-qty]').querySelector('input');
    var min = parseInt(input.min || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.qtyStep, 10));
    input.value = next;
    if (cartForm && cartForm.contains(input)) submitCart();
  });
  if (cartForm) {
    cartForm.addEventListener('change', function (e) {
      if (e.target.matches('.qty__input')) submitCart();
    });
  }

  /* Auto-submit selects (collection sort) */
  document.querySelectorAll('[data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () { el.form.submit(); });
  });

  /* Password visibility */
  document.querySelectorAll('[data-password-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input');
      input.type = input.type === 'password' ? 'text' : 'password';
    });
  });

  /* Confirm address delete */
  document.querySelectorAll('form[data-confirm]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.confirm(form.dataset.confirm)) e.preventDefault();
    });
  });

  /* Product gallery */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var thumbs = gallery.querySelectorAll('[data-thumb-index]');
    if (!track) return;
    function setActive(index) {
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(thumb.dataset.thumbIndex, 10);
        track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
        setActive(index);
      });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        setActive(Math.round(track.scrollLeft / track.clientWidth));
        ticking = false;
      });
    }, { passive: true });
    gallery.goToMedia = function (mediaId) {
      var slides = track.children;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].dataset.mediaId === String(mediaId)) {
          track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
          setActive(i);
          break;
        }
      }
    };
  });

  /* Variant selection */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var jsonEl = section.querySelector('[data-product-json]');
    var form = section.querySelector('[data-product-form]');
    if (!jsonEl || !form) return;
    var variants = JSON.parse(jsonEl.textContent);
    var selects = form.querySelectorAll('[data-option-index]');
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-button]');
    var addLabel = form.querySelector('[data-add-label]');
    var priceCurrent = section.querySelector('[data-price-current]');
    var priceCompare = section.querySelector('[data-price-compare]');
    var gallery = section.querySelector('[data-gallery]');

    function onChange() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var variant = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      if (!variant) {
        addBtn.disabled = true;
        addLabel.textContent = theme.strings.unavailable;
        return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
      if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price);
      if (priceCompare) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceCompare.hidden = !onSale;
        priceCompare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      }
      if (variant.featured_media && gallery && gallery.goToMedia) gallery.goToMedia(variant.featured_media.id);
      var url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
    selects.forEach(function (s) { s.addEventListener('change', onChange); });
  });

  /* Add to cart */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
    document.querySelectorAll('[data-cart-count-plain]').forEach(function (el) { el.textContent = count; });
  }

  function showToast(html) {
    var existing = document.querySelector('.toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML = html;
    document.body.appendChild(toast);
    setTimeout(function () { toast.remove(); }, 5000);
  }

  var stayOnPage = document.body.dataset.cartBehaviour === 'stay';

  document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!stayOnPage || !window.fetch) return; // default: normal post, Shopify redirects to /cart
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var label = form.querySelector('[data-add-label]');
      var message = form.querySelector('[data-form-message]');
      var original = label ? label.textContent : null;
      if (btn) btn.disabled = true;
      if (label) label.textContent = theme.strings.adding;
      if (message) message.hidden = true;

      fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || theme.strings.error);
          return fetch(theme.routes.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          showToast('<span>' + theme.strings.added + '</span><a href="' + theme.routes.cart + '">' + theme.strings.viewCart + '</a>');
        })
        .catch(function (err) {
          if (message) {
            message.textContent = err.message;
            message.classList.add('form-message--error');
            message.hidden = false;
          } else {
            showToast('<span>' + err.message + '</span>');
          }
        })
        .finally(function () {
          if (btn) btn.disabled = false;
          if (label && original) label.textContent = original;
        });
    });
  });
})();
